import BisonPDFFile from './Bison_Pricelist APRIL 2022.pdf';
import TaxidermyPDF from './Taxidermy Price List JUNE 2022.pdf';
import FurPriceListPDF from './Fur_Pricelist NOV 2024.pdf';

import LaceyActPDF from './Lacey_Act.pdf';
import ExemptionPDF from './Exemption.pdf';
import OrderFormPDF from './Manual_order_form.pdf';
import ShippingLabelPDF from './Shipping_Label.pdf';

import AfricanPDF from './African Price List (SALTED) NOV 2024.pdf';
import ExoticPDF from './Exotic Price List (SALTED) NOV 2024.pdf';
import NAmericanPDF from './North American Price List (FROZEN & SALTED) NOV 2024.pdf';

import ExoticSaltedPDF from './Exotic Price List (FROZEN & SALTED) NOV 2024.pdf';
import NAmericanSaltedPDF from './North American Price List (SALTED) NOV 2024.pdf';

const BisonDocument = {
    file: BisonPDFFile,
    name: 'Bison_Pricelist APRIL 2022.pdf',
    size: 0.1,
};
const TaxidermyDocument = {
    file: TaxidermyPDF,
    name: 'Taxidermy Price List JUNE 2022.pdf',
    size: 0.5,
};

const FurPriceDocument = {
    file: FurPriceListPDF,
    name: 'Fur_Pricelist NOV 2024.pdf',
    size: 0.9,
};

const LaceyActDocument = {
    file: LaceyActPDF,
    name: 'Lacey_Act.pdf',
    size: 0.1,
};

const ExemptionDocument = {
    file: ExemptionPDF,
    name: 'Exemption.pdf',
    size: 0.2,
};

const OrderFormDocument = {
    file: OrderFormPDF,
    name: 'Manual_order_form.pdf',
    size: 0.5,
};

const ShippingLabelDocument = {
    file: ShippingLabelPDF,
    name: 'Shipping_Label.pdf',
    size: 0.05,
};

const AfricanDocument = {
    file: AfricanPDF,
    name: 'African Price List (SALTED) NOV 2024.pdf',
    size: 3.6,
};

const ExoticDocument = {
    file: ExoticPDF,
    name: 'Exotic Price List (FROZEN & SALTED) NOV 2024.pdf',
    size: 2.7,
};

const NAmericanDocument = {
    file: NAmericanPDF,
    name: 'North American Price List (FROZEN & SALTED) NOV 2024.pdf',
    size: 3.3,
};

const ExoticSaltedDocument = {
    file: ExoticSaltedPDF,
    name: 'Exotic Price List (SALTED) NOV 2024.pdf',
    size: 1.4,
};

const NAmericanSaltedDocument = {
    file: NAmericanSaltedPDF,
    name: 'North American Price List (SALTED) NOV 2024.pdf',
    size: 1.3,
};

export {
    BisonDocument,
    TaxidermyDocument,
    FurPriceDocument,
    LaceyActDocument,
    ExemptionDocument,
    OrderFormDocument,
    ShippingLabelDocument,
    AfricanDocument,
    ExoticDocument,
    NAmericanDocument,
    ExoticSaltedDocument,
    NAmericanSaltedDocument,
};
